import swal from '../swal';
import errorMsg from '../errorMsg';

// const XH_INVOKE_LOGIN = 'XH_INVOKE_LOGIN';
const XH_REPORT_RESULT = 'XH_REPORT_RESULT';

const {protocol, host} = location;
const targetOrigin = `${protocol}//${host}`;

const invokeLogin = (fr) => {
    if (fr !== 'community') swal.error(errorMsg.LOGIN_ALERT);
};

const reportResult = (result = 1) => {
    const data = JSON.stringify({
        type: XH_REPORT_RESULT,
        payload: {result}
    });
    window.parent.postMessage(data, targetOrigin);
};

/**
 * 向社区发送登录消息
 */
const showLoginBox = () => {
    const data = JSON.stringify({
        type: 'SHOW_LOGIN_BOX',
        payload: {}
    })
    window.parent.postMessage(data, '*')
}

const changeUrl = (projectId) => {
    const data = JSON.stringify({
        type: 'CHANGE_PROJECT_ID',
        payload: {projectId}
    })
    window.parent.postMessage(data, '*')
}

// const scratchCheckpointSaved = payload => {
//     const data = JSON.stringify({
//         type: 'XH_SCRATCH_CHECKPOINT_SAVE',
//         payload
//     });
//     parent.postMessage(data, '*');
//     if (window.opener) {
//         window.opener.postMessage(data, '*');
//     }
// };

export {
    invokeLogin,
    reportResult,
    showLoginBox,
    changeUrl,
    // scratchCheckpointSaved
};
